export default "__VITE_ASSET__BV31ZN_5__"